<template>
    <div class="notifications-card">
      <img src="/images/promo/connect-features/notifications-card.svg" alt="Notifications card" />
    </div>
</template>

<script>
export default {};
</script>
